document.addEventListener('DOMContentLoaded', function () {
    var popup = document.getElementById('age-verification-popup');
    var overlay = document.getElementById('popup-overlay');
    var yesButton = document.getElementById('popup-yes');
    var noButton = document.getElementById('popup-no');
    var titleElement = document.getElementById('popup-title');
    var bodyTextElement = document.getElementById('popup-body-text');
    var topImage = document.getElementById('popup-top-image');
    var backgroundImage = document.getElementById('popup-background-image');
    var settings = window.popupSettings || {};
    const defaultImageURL = '//cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
    const defaultImageURL1 = '//keksroom.myshopify.com/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
    const defaultImageURL2 = '//keksroom.com/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
    // Check localStorage to see if the user has already verified their age
    if (!localStorage.getItem('ageVerified')) {
        // Show the pop-up and overlay
        popup.style.display = 'block';
        overlay.style.display = 'block';

        // Prevent scrolling
        document.body.style.overflow = 'hidden';
    }

    yesButton.addEventListener('click', function () {
        popup.style.display = 'none';
        overlay.style.display = 'none';
        document.body.style.overflow = 'auto';
        
        // Store the age verification in localStorage
        localStorage.setItem('ageVerified', 'true');
    });

    noButton.addEventListener('click', function () {
        window.location.href = 'https://www.google.com';
    });

    // Set text and styles from Shopify customizer settings
    titleElement.innerText = settings.title || 'Default Title';
    bodyTextElement.innerText = settings.bodyText || 'Default Body Text';
    
    // Set CSS variables for text and button styles
    document.documentElement.style.setProperty('--popup-text-color', settings.textColor || '#000');
    document.documentElement.style.setProperty('--popup-button-text-color', settings.buttonTextColor || '#000');
    document.documentElement.style.setProperty('--popup-button-border-color', settings.buttonBorderColor || '#000');
    document.documentElement.style.setProperty('--popup-button-bg-color', 'transparent');
    
    // Set button text
    yesButton.innerText = settings.popupYesButtonText || 'Yes, I\'m 18';
    noButton.innerText = settings.popupNoButtonText || 'No, I\'m not 18';

// Temporary: force white background
popup.style.backgroundImage = 'none';
popup.style.backgroundColor = 'white';

    // Set top image visibility and adjust content positioning
    if (settings.topImage && settings.topImage.trim() !== '' && settings.topImage !== defaultImageURL && settings.topImage !== defaultImageURL1 && settings.topImage !== defaultImageURL2) {
        topImage.src = settings.topImage;
        topImage.style.display = 'block';
    } else {
        topImage.style.display = 'none';
    }

  
});

document.addEventListener("DOMContentLoaded", function() {
  const warrantyCheckbox = document.getElementById('warranty-checkbox');
  const warrantyOptions = document.getElementById('warranty-options');
  const addToCartButton = document.querySelector('form.product-form button[type="submit"]');

  warrantyCheckbox && warrantyCheckbox.addEventListener('change', function() {
    if(warrantyOptions) warrantyOptions.style.display = this.checked ? 'block' : 'none';
  });

  addToCartButton && addToCartButton.addEventListener('click', function(event) {
    if (warrantyCheckbox.checked) {
      const selectedWarranty = document.querySelector('input[name="warranty"]:checked');
      if (!selectedWarranty) {
        alert('Пожалуйста, выберите срок расширенной гарантии.');
        event.preventDefault();
        return;
      }

      // Добавление гарантии в корзину вместе с основным продуктом
      const warrantyVariantId = selectedWarranty.value === '1_year' ? 'вібратор-bluetooth' : 'гель-смазка';
      addToCart(warrantyVariantId);
    }
  });

  function addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Гарантия добавлена в корзину:', data);
    })
    .catch(error => {
      console.error('Ошибка при добавлении гарантии:', error);
    });
  }
});



